import React from "react";
import { Box, Flex } from "rebass";
import styled from "styled-components";
import { TCountIndicator, TCountProps } from "../../@types";

export const CountIndicator: React.FC<TCountIndicator> = ({
  heading,
  count,
  max,
  canProceed,
}) => {
  return (
    <CountWrapper>
      <Box
        mr={2}
        style={{
          color: "var(--Ice-100, #F7FCFD)",
          fontFamily: "Barlow",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "48px",
          letterSpacing: "0.026px",
        }}
      >
        {heading}
      </Box>
      <Count count={count} max={max} canProceed={canProceed} />
    </CountWrapper>
  );
};

export const Count = ({ count, max, canProceed }: TCountProps) => {
  return (
    <>
      <Flex flexDirection={"row"} alignItems={"center"} style={{ gap: "4px" }}>
        <SelectedCount canProceed={canProceed}>
          {count > 0 ? count : 0}
        </SelectedCount>
        <Slash>/</Slash>
        <Max>{max}</Max>
      </Flex>
    </>
  );
};

const CountWrapper = styled.div`
  color: #f7fcfd;
  display: flex;
  align-items: center;
  font-family: "Barlow";
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 28px;
  cursor: default;
`;

type TSelectedCountProps = {
  canProceed: boolean;
};

const SelectedCount = styled.div<TSelectedCountProps>`
  color: ${(props: TSelectedCountProps) => {
    return props.canProceed ? "#c6bcf5" : "rgba(198, 188, 245, 0.60)";
  }};
  font-family: Barlow;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
  letter-spacing: 0.026px;
`;

const Max = styled.div<any>`
  color: var(--Ice-100, #f7fcfd);
  font-family: Barlow;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.026px;
`;
const Slash = styled.div<any>`
  color: var(--Ice-100, #f7fcfd);
  font-family: Barlow;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.026px;
`;
